// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4145) return "js/frontend/4145.js";
	if (chunkId === 2299) return "js/frontend/2299.js";
	// return url for filenames based on template
	return undefined;
};